module.exports = __webpack_public_path__ + "static/media/place.cbbac8cc.svg";